import { useCallback, useEffect, useRef } from 'react';

// eslint-disable-next-line new-cap -- Intercom SDK exports an uppercase init function
import intercom, { hide, show, shutdown } from '@intercom/messenger-js-sdk';

const INTERCOM_APP_ID = 'qsl2vvw9';

interface UseIntercomOptions {
  enabled?: boolean;
}

export const useIntercom = ({ enabled = true }: UseIntercomOptions = {}) => {
  const bootedRef = useRef(false);

  useEffect(() => {
    if (!enabled) {
      return undefined;
    }

    if (bootedRef.current) {
      return undefined;
    }

    intercom({
      app_id: INTERCOM_APP_ID,
      hide_default_launcher: true,
    });
    bootedRef.current = true;

    return () => {
      shutdown();
      bootedRef.current = false;
    };
  }, [enabled]);

  const openChat = useCallback(
    (user?: { name: string; email: string }) => {
      if (!enabled) return;

      if (user) {
        intercom({
          app_id: INTERCOM_APP_ID,
          hide_default_launcher: true,
          user_id: user.email,
          name: user.name,
          email: user.email,
        });
      }

      show();
    },
    [enabled],
  );

  const closeChat = useCallback(() => {
    if (!enabled) return;
    hide();
  }, [enabled]);

  const toggleChat = useCallback(() => {
    if (!enabled) return;
    show();
  }, [enabled]);

  return {
    openChat,
    closeChat,
    toggleChat,
  };
};
